import { Table } from '@flos/react-ui';
import CoverageTextModalTableCell from './CoverageTextModalTableCell';

const CoverageTable = ({
    included = [],
    excluded = [],
    includedTitle,
    excludedTitle
}: {
    included?: string[];
    excluded?: string[];
    includedTitle?: string;
    excludedTitle?: string;
}): React.JSX.Element => {
    const numberOfRows = Math.max(included?.length ?? 0, excluded?.length ?? 0);
    return (
        <Table wrapped={true} mobileDirection="vertical">
            <Table.Body className="u-display-none u-display-table-row-group@xs tbody@xs">
                <Table.Row>
                    {!!included.length && (
                        <Table.HeadCell className="u-spacing-inset-top-4 u-spacing-inset-bottom-4">
                            {includedTitle}
                        </Table.HeadCell>
                    )}
                    {!!excluded.length && (
                        <Table.HeadCell className="u-spacing-inset-top-4 u-spacing-inset-bottom-4">
                            {excludedTitle}
                        </Table.HeadCell>
                    )}
                </Table.Row>

                {Array.from({ length: numberOfRows }).map((_, i) => (
                    <Table.Row key={i} className="u-border-supplement-grey-light">
                        {included?.[i] ? (
                            <CoverageTextModalTableCell
                                text={included?.[i]}
                                iconProps={{
                                    size: 'medium',
                                    shape: 'circle-check',
                                    className: 'has-fill is-green'
                                }}
                            />
                        ) : (
                            <Table.Cell />
                        )}
                        {excluded?.[i] && (
                            <CoverageTextModalTableCell
                                text={excluded?.[i]}
                                iconProps={{
                                    size: 'medium',
                                    shape: 'circle-close',
                                    className: 'has-fill is-grey'
                                }}
                            />
                        )}
                    </Table.Row>
                ))}
            </Table.Body>

            <Table.Body className="u-display-none@xs tbody">
                <Table.Row>
                    {included?.map((includedText) => (
                        <CoverageTextModalTableCell
                            dataHeader={includedTitle}
                            key={includedText}
                            text={includedText}
                            iconProps={{
                                size: 'medium',
                                shape: 'circle-check',
                                className: 'has-fill is-green'
                            }}
                        />
                    ))}
                </Table.Row>
                <Table.Row>
                    {excluded?.map((excludedText) => (
                        <CoverageTextModalTableCell
                            dataHeader={excludedTitle}
                            key={excludedText}
                            text={excludedText}
                            iconProps={{
                                size: 'medium',
                                shape: 'circle-close',
                                className: 'has-fill is-grey'
                            }}
                        />
                    ))}
                </Table.Row>
            </Table.Body>
        </Table>
    );
};

export default CoverageTable;
